import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import Check from '@kyruus/react-ikons/Check';

import { BREAKPOINTS } from '../../lib/constants';
// eslint-disable-next-line import/extensions
import { dotSpacer } from '../../lib/styles/dot-spacer.styles';

const infoCardsColumnGap = fromTheme('spacing_large');

export const CardsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  row-gap: ${fromTheme('spacing_medium')};
  column-gap: ${infoCardsColumnGap};
  margin-top: ${fromTheme('spacing_medium')};
  width: 100%;

  @media only screen and (min-width: ${BREAKPOINTS.small}px) {
    width: calc(100% + ${infoCardsColumnGap});
  }
`;

export const ProviderInformationCard = styled.div`
  position: relative;
  flex: 1 1 100%;
  max-width: 100%;
  font-size: ${fromTheme('font_size')};
  padding: 0;

  @media only screen and (min-width: ${BREAKPOINTS.small}px) {
    flex: 1 1 calc(50% - ${infoCardsColumnGap});
    max-width: calc(50% - ${infoCardsColumnGap});
  }
`;

export const ProviderAffiliationsCard = styled(ProviderInformationCard)`
  margin-top: ${fromTheme('spacing_medium')};

  @media only screen and (min-width: ${BREAKPOINTS.small}px) {
    max-width: 100%;
  }
`;

export const CardContentContainer = styled.div`
  overflow: hidden;
  // This padding value is to fix letter and outline cutting from bottom inside the container
  padding: 3px;
`;

export const CardContentHeader = styled.h3`
  font-weight: ${fromTheme('font_weight_bolder')};
  font-size: ${fromTheme('font_size')};
  margin: 0 0 ${fromTheme('spacing_small')} 0;
  color: ${fromTheme('color_text')};
`;

const cardContentListColumnGap = fromTheme('spacing_xsmall');
export const CardContentHorizontalList = styled.ul`
  margin: 0;
  padding: 0;

  color: ${fromTheme('color_text')};
`;

export const CardContentHorizontalListItem = styled.li`
  display: inline-block;
  list-style: none;
  margin: 0 ${fromTheme('spacing_xsmall')} ${fromTheme('spacing_xsmall')} 0;
  padding: 0;

  & + li:before {
    ${(props: any) =>
      dotSpacer({
        marginLeft: 'initial',
        marginRight: cardContentListColumnGap(props)
      })}
  }
`;

export const CardContentAnchor = styled.a`
  text-decoration: none;
  color: ${fromTheme('color_info')};

  &:hover {
    text-decoration: underline;
  }

  @media print {
    display: none;
  }
`;

export const CardContentText = styled.span`
  color: ${fromTheme('color_text')};
`;

export const CheckmarkContainer = styled.span`
  position: absolute;
  top: -1rem;
  right: -1rem;
  color: #00cfb5;
`;

export const CheckMark = styled(Check)`
  position: absolute;
  // these styles need overriding in order to render correctly in PMC (https://kyruus.jira.com/browse/KENG-34177)
  left: 6px;
  top: 7px;
  color: ${fromTheme('color_background')};
`;

export const FilterMatchClearButton = styled.button`
  background: none;
  border: none;
  font-size: ${fromTheme('font_size_small')};
  color: ${fromTheme('color_info')};
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  @media print {
    display: none;
  }
`;

export const MoreTooltipContent = styled.span`
  border-bottom: 1px dotted;
  display: inline-block;
  padding-bottom: 1px;

  &:hover {
    cursor: pointer;
  }
`;

export const HighlightsSectionHeader = styled.h2`
  margin: 0;
  font-weight: ${fromTheme('font_weight_bolder')};
  margin-bottom: ${fromTheme('spacing_medium')};
  color: ${fromTheme('color_text')};
  font-size: ${fromTheme('font_size_heading_4')};
`;
